module.exports = __webpack_public_path__ + "static/media/heart-o.5a8a7c10.svg";